<div class="form form-horizontal mb-20" [formGroup]="sliderForm">
    <div class="datetime-slider">
        <ngx-slider formControlName="sliderControl" [options]="options" (userChangeEnd)="onChangeEnd($event)">
        </ngx-slider>
    </div>
</div>
